import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '@clerk/clerk-react';
import { IconButton } from '@/components/ui';
import { Icon } from '@/lib/icons';
import { AssistantPanel } from './AssistantPanel';

/* The slide-over. Keeps the current thread per client in sessionStorage so
   closing and reopening continues the same conversation, and "expand" jumps to
   the full page with that thread open. */
export function AssistantDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const { organization } = useOrganization();
  const key = `tq.assistant.thread.${organization?.id ?? ''}`;
  const [threadId, setThreadId] = useState<string | null>(null);

  useEffect(() => {
    try { setThreadId(sessionStorage.getItem(key)); } catch { setThreadId(null); }
  }, [key]);
  const setThread = (id: string | null) => {
    setThreadId(id);
    try { if (id) sessionStorage.setItem(key, id); else sessionStorage.removeItem(key); } catch { /* per-tab convenience only */ }
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="lead-drawer asst-drawer" role="dialog" aria-label="Ask tritonIQ">
      <div className="lead-drawer__scrim" onClick={onClose} />
      <div className="lead-drawer__panel asst-drawer__panel">
        <div className="asst-drawer__top">
          <strong><Icon name="sparkles" size={16} /> Ask tritonIQ</strong>
          <div className="asst-drawer__actions">
            <button type="button" className="asst-drawer__link" onClick={() => setThread(null)}>New conversation</button>
            <IconButton label="Open full page" variant="outline" onClick={() => { onClose(); navigate(threadId ? `/assistant?thread=${threadId}` : '/assistant'); }}><Icon name="layout" size={16} /></IconButton>
            <IconButton label="Close" variant="outline" onClick={onClose}><Icon name="x" size={16} /></IconButton>
          </div>
        </div>
        <AssistantPanel threadId={threadId} onThread={setThread} compact onNavigate={onClose} />
      </div>
    </div>
  );
}
